import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { InputNumberProps } from "./PropsType";

export default function InputNumber(props: InputNumberProps) {
  const {
    className,
    min,
    max,
    prefixCls = "bm-InputNumber",
    style,
    type = 1,
    step = 1,
  } = props;
  const initial = useRef(false);
  const [value, setVValue] = useState(
    typeof props.defaultValue === "number" ? props.defaultValue : 0
  );
  const styleClass = classNames(
    prefixCls,
    {
      [`${prefixCls}-2`]: type === 2,
    },
    className
  );
  const steps = step?.toString()?.split(".") || [];
  const count: number = steps[1] ? steps[1].length : 0;
  const minusStyleClass = classNames(`${prefixCls}-minus`, {
    "is-disabled": min! <= value!,
  });
  const addStyleClass = classNames(`${prefixCls}-add`, {
    "is-disabled": max! >= value!,
  });
  const arrowStyle: any = {
    pointerEvents: "none",
    display: "block",
    fill: "rgb(117, 117, 117)",
  };

  const setValue = (add: number = 0, value: number = 0) => {
    let currentValue = value! + add * step!;
    if (currentValue < min!) {
      currentValue = min!;
    } else if (currentValue > max!) {
      currentValue = max!;
    }
    currentValue = Number(currentValue.toFixed(count));
    setVValue(currentValue);
    return currentValue;
  };

  const spin = (add: number, event: Event) => {
    const { onChange } = props;
    const currentValue = setValue(add, value);
    if (onChange) {
      onChange({
        value: currentValue,
        originalEvent: event,
      });
    }
  };

  const handleKeyDown = (event: any) => {
    if (event.which === 38) {
      spin(1, event);
      event.preventDefault();
    } else if (event.which === 40) {
      spin(-1, event);
      event.preventDefault();
    }
  };

  const handleKeyPress = (event: any) => {
    const keyPattern: RegExp = /[0-9\+\-]/;
    if (
      !keyPattern.test(String.fromCharCode(event.charCode)) &&
      event.keyCode !== 9 &&
      event.keyCode !== 8 &&
      event.keyCode !== 37 &&
      event.keyCode !== 39 &&
      event.keyCode !== 46
    ) {
      event.preventDefault();
    }
  };

  const handleChange = (event: any) => {
    const inputElem: any = event.target;
    const { onChange } = props;
    setVValue(Number(inputElem.value));
    if (onChange) {
      onChange({
        value,
        originalEvent: event,
      });
    }
  };

  useEffect(() => {
    if (!initial.current) {
      initial.current = true;
      return;
    }
    setValue(0, props.value);
  }, [props.value]);

  return (
    <div className={styleClass} style={style}>
      {type !== 2 ? (
        <button className={minusStyleClass} onClick={spin.bind(null, -1)} />
      ) : null}
      <input
        type="text"
        value={value}
        onKeyDown={handleKeyDown}
        onKeyPress={handleKeyPress}
        onChange={handleChange}
      />
      {type !== 2 ? (
        <button className={addStyleClass} onClick={spin.bind(null, 1)} />
      ) : null}
      {type === 2 ? (
        <div className={`${prefixCls}-step`}>
          <span onClick={spin.bind(null, 1)} className="bm-rotate-180">
            <svg
              viewBox="0 0 24 24"
              preserveAspectRatio="xMidYMid meet"
              style={arrowStyle}
            >
              <g>
                <path d="M7 10l5 5 5-5z" />
              </g>
            </svg>
          </span>
          <span onClick={spin.bind(null, -1)}>
            <svg
              viewBox="0 0 24 24"
              preserveAspectRatio="xMidYMid meet"
              style={arrowStyle}
            >
              <g>
                <path d="M7 10l5 5 5-5z" />
              </g>
            </svg>
          </span>
        </div>
      ) : null}
    </div>
  );
}
